@if(!hideHeader && isLogged) {
<app-header></app-header>
}
<div class="app">
  <div class="app__content">
    <router-outlet class="app__router-outlet"></router-outlet>
  </div>
</div>
